'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-layout-full-width-sidebar';
var cnOuterWrapper = "".concat(CLASSNAME, "__outer-wrapper");
var cnInnerWrapper = "".concat(CLASSNAME, "__inner-wrapper");
var cnInnerWrapperFooter = "".concat(cnInnerWrapper, "--footer");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function LayoutFullWidthSidebar(_ref) {
  var className = _ref.className,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, header, /*#__PURE__*/React__default.createElement("main", null, children), /*#__PURE__*/React__default.createElement(LayoutFullWidthSidebar.Wrapper, {
    className: cnInnerWrapperFooter
  }, footer));
}
LayoutFullWidthSidebar.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node
};
/**
 * 
 * @param {*} param0 
 * @returns 
 */

LayoutFullWidthSidebar.Wrapper = function Wrapper(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cnOuterWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(cnInnerWrapper, className)
  }, children));
};

LayoutFullWidthSidebar.Wrapper.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name */
  className: PropTypes.string
};

module.exports = LayoutFullWidthSidebar;
